var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("d2-container", [
    _c("div", { staticClass: "dashboard" }, [
      _c("div", { staticClass: "welcome-banner" }, [
        _c("div", { staticClass: "welcome-text" }, [
          _c("h2", [_vm._v("欢迎使用" + _vm._s(_vm.title))]),
          _c("p", [_vm._v("今日是 " + _vm._s(_vm.today))])
        ]),
        _c("div", { staticClass: "welcome-deco" }, [
          _c("i", { staticClass: "fa fa-dragon" })
        ])
      ]),
      _c(
        "div",
        { staticClass: "kpi-row" },
        _vm._l(_vm.kpiData, function(item) {
          return _c("div", { key: item.title, staticClass: "kpi-card" }, [
            _c(
              "div",
              { staticClass: "kpi-icon", style: { background: item.bg } },
              [_c("i", { class: item.icon })]
            ),
            _c("div", { staticClass: "kpi-info" }, [
              _c("div", { staticClass: "kpi-value" }, [
                _vm._v(_vm._s(item.value))
              ]),
              _c("div", { staticClass: "kpi-label" }, [
                _vm._v(_vm._s(item.title))
              ]),
              _c(
                "div",
                {
                  staticClass: "kpi-trend",
                  class: item.trend > 0 ? "up" : "down"
                },
                [
                  _c("i", {
                    class:
                      item.trend > 0 ? "fa fa-arrow-up" : "fa fa-arrow-down"
                  }),
                  _c("span", [_vm._v(_vm._s(Math.abs(item.trend)) + "%")]),
                  _c("span", { staticClass: "trend-period" }, [
                    _vm._v("较昨日")
                  ])
                ]
              )
            ]),
            _c(
              "div",
              { staticClass: "kpi-sparkline" },
              [
                _c("ve-line", {
                  attrs: {
                    data: item.chartData,
                    settings: item.chartSettings,
                    height: "50px",
                    extend: _vm.sparkExtend
                  }
                })
              ],
              1
            )
          ])
        }),
        0
      ),
      _c("div", { staticClass: "chart-row" }, [
        _c("div", { staticClass: "chart-card chart-main" }, [
          _c("div", { staticClass: "chart-header" }, [
            _c("h3", [_vm._v("营收趋势")]),
            _c(
              "div",
              { staticClass: "chart-tabs" },
              _vm._l(_vm.chartTabs, function(tab) {
                return _c(
                  "span",
                  {
                    key: tab.key,
                    class: ["chart-tab", { active: _vm.activeTab === tab.key }],
                    on: {
                      click: function($event) {
                        _vm.activeTab = tab.key
                      }
                    }
                  },
                  [_vm._v(_vm._s(tab.label))]
                )
              }),
              0
            )
          ]),
          _c(
            "div",
            { staticClass: "chart-body" },
            [
              _c("ve-line", {
                attrs: {
                  data: _vm.revenueData,
                  extend: _vm.revenueExtend,
                  height: "320px"
                }
              })
            ],
            1
          )
        ]),
        _c("div", { staticClass: "chart-card chart-side" }, [
          _c("div", { staticClass: "chart-header" }, [
            _c("h3", [_vm._v("用户分布")])
          ]),
          _c(
            "div",
            { staticClass: "chart-body" },
            [
              _c("ve-pie", {
                attrs: {
                  data: _vm.userData,
                  extend: _vm.pieExtend,
                  height: "320px"
                }
              })
            ],
            1
          )
        ])
      ]),
      _c("div", { staticClass: "quick-section" }, [
        _c("div", { staticClass: "section-title" }, [
          _c("span", { staticClass: "title-deco" }),
          _c("h3", [_vm._v("快捷入口")])
        ]),
        _c(
          "div",
          { staticClass: "quick-grid" },
          _vm._l(_vm.quickActions, function(action) {
            return _c(
              "div",
              {
                key: action.title,
                staticClass: "quick-card",
                on: {
                  click: function($event) {
                    return _vm.handleQuickAction(action)
                  }
                }
              },
              [
                _c("div", { staticClass: "quick-icon" }, [
                  _c("i", { class: action.icon })
                ]),
                _c("div", { staticClass: "quick-info" }, [
                  _c("div", { staticClass: "quick-title" }, [
                    _vm._v(_vm._s(action.title))
                  ]),
                  _c("div", { staticClass: "quick-desc" }, [
                    _vm._v(_vm._s(action.desc))
                  ])
                ]),
                _c("i", { staticClass: "fa fa-arrow-right quick-arrow" })
              ]
            )
          }),
          0
        )
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }